import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class CancelPlanService {
  constructor(private http: HttpClient) {}

  getCancelPlanList(planId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getSubscriberPlanDetails/' + planId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  insertCancelPlanDetail(cancel_plan_data): Observable<any> {
    const post_url = baseApiUrl + 'subscriber/cancelPlan';
    return this.http.post<any>(post_url,cancel_plan_data,{ headers: httpOptions.headers}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
getRefundOption(){
  const get_url = baseApiUrl + 'commonList/generic/refundOptionType';
  return this.http.get<any>(get_url)
}
  getTaxDetailByPlan(data: any): Observable<any> {
    const post_url = baseApiUrl + 'getTaxDetails/byPlan';
    return this.http.post<any>(post_url, data, httpOptions)
      .pipe(map(res => res),
      catchError((error: any) => {
        return throwError(error);
      })
      );
  }
}
